/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Snigdha <snigdha.dhanireddy@mroads.com>, February 2021
 * @format
 * @flow
 */

import { all, takeLatest } from 'redux-saga/effects';
import { ActionTypes } from '../constants';
import API from '../../requests';
import { callAPI } from './callAPI';

export function* emailReceipt({ payload }): any {
  yield callAPI(payload, ActionTypes.EMAIL_RECEIPT, API.emailReceipt, false);
}

export function* smsReceipt({ payload }): any {
  yield callAPI(payload, ActionTypes.SMS_RECEIPT, API.smsReceipt, false);
}

export function* printReceipt({ payload }): any {
  yield callAPI(payload, ActionTypes.PRINT_RECEIPT, API.receiptPrint, false);
}

export default function* root(): any {
  yield all([
    takeLatest(ActionTypes.EMAIL_RECEIPT_REQUEST, emailReceipt),
    takeLatest(ActionTypes.SMS_RECEIPT_REQUEST, smsReceipt),
    takeLatest(ActionTypes.PRINT_RECEIPT_REQUEST, printReceipt),
  ]);
}
